import Store from 'redux/store';
import { trackingLTM } from '../clients';

import { FETCH_TRACKING, FETCH_TRACKING_SUCCESS, FETCH_TRACKING_FAIL } from 'redux/Reducers/Tracking/TrackingReducer';

export const FetchTracking = async (User, finallyCallback = () => {}, { vendorOrderId , vendorId, productCode }) => {
    Store.dispatch({ type: FETCH_TRACKING });
    trackingLTM().get(`/timelines/${vendorOrderId}/vendor/${vendorId}/items/${productCode}`)
    .then(({data: { deliveryForecast, sku, statuses }}) => {
        Store.dispatch({
            type: FETCH_TRACKING_SUCCESS,
            payload: {
                deliveryForecast,
                sku,
                statuses,
            },
        });
    })
    .catch((e) => {
        Store.dispatch({
            type: FETCH_TRACKING_FAIL,
            payload: {
                error: e
            }
        });
    })
    .finally(() => {
        finallyCallback();
    });
};
